import { createAuthClient } from 'better-auth/react';
import { passkeyClient } from '@better-auth/passkey/client';
import { oneTapClient } from 'better-auth/client/plugins';
import { API_URL, GOOGLE_CLIENT_ID } from './env';

export const authClient = createAuthClient({
  baseURL: API_URL,
  fetchOptions: {
    credentials: 'include',
  },
  plugins: [
    passkeyClient(),
    ...(GOOGLE_CLIENT_ID ? [oneTapClient({ clientId: GOOGLE_CLIENT_ID })] : []),
  ],
});

export const { signIn, signUp, signOut, useSession } = authClient;
